import { safeExternalUrl as safeActivityLink } from '../../config/navigation.js';
const image = url => typeof url === 'string' && /^\/(?!\/)/.test(url) ? url : safeActivityLink(url);
// Public display data is never a participation state: no personal facts or action keys.
const sectionByTitle = (sections, title) => sections.find(section => section?.title === title);
const rows = section => Array.isArray(section?.items) ? section.items : [];
const items = section => rows(section).map((item, index) => ({ key: `public-${index}`, title: item.title, imageUrl: item.imageUrl, publicDetail: item.detail }));

export function publicGameplayView(activityType, sections = []) {
  if (!Array.isArray(sections) || !sections.length) return null;
  const rules = {};
  let publicCaption = '';
  if (activityType === 'DEPOSIT_STREAK') {
    const section = sectionByTitle(sections, '连续存款奖励');
    if (!rows(section).length) return null;
    rules.milestones = items(section);
    publicCaption = section.description;
  } else if (activityType === 'PREDICTION') {
    rules.pages = sections.filter(section => section.title !== '活动任务').map((section, index) => ({ key: `public-${index}`, title: section.title, description: section.description, options: items(section), publicReadOnly: true }));
  } else if (['CARD_COLLECTION', 'THEME_DRAW'].includes(activityType)) {
    const pool = sectionByTitle(sections, '本期奖池');
    rules[activityType === 'CARD_COLLECTION' ? 'cards' : 'prizes'] = items(pool);
    rules.groups = items(sectionByTitle(sections, '集卡兑换'));
    publicCaption = pool?.description;
  } else return null;
  rules.tasks = items(sectionByTitle(sections, '活动任务'));
  return { activityType, rules, publicReadOnly: true, publicCaption, progress: [] };
}

export function publicNewcomerView(activity, reason = '') {
  const section = sectionByTitle(activity?.ruleSections || [], '活动任务');
  if (!rows(section).length) return null;
  return {
    publicReadOnly: true, title: activity.title,
    hero: image(activity.mainImageUrl) ? { src: image(activity.mainImageUrl), alt: activity.title } : null,
    tasks: rows(section).map((item, index) => ({ id: `public-${index}`, title: item.title, displayDetail: item.detail, completed: null, claimed: null })),
    eligible: reason ? false : null, claimed: null, canClaim: false, claimAvailable: false, readOnlyTaskNavigation: false,
    error: reason, capabilityNotice: reason, registrationDate: '', publicDescription: section.description
  };
}

export function publicVoteView(activity) {
  const sections = activity?.ruleSections || [];
  const candidates = rows(sectionByTitle(sections, '投票候选'));
  if (!candidates.length) return null;
  const stages = items(sectionByTitle(sections, '投票阶段')).map(item => ({ id: item.key, label: item.title, publicDetail: item.publicDetail, status: '' }));
  return {
    publicReadOnly: true, canVote: false, eligible: false, availableVotes: '—',
    hero: image(activity.mainImageUrl) ? { src: image(activity.mainImageUrl), alt: activity.title } : null,
    stageId: stages[0]?.id || '', stages, rankIsDisplayOrder: true,
    rankingNotice: '按活动配置顺序展示，实际票数和排名待确认。',
    candidates: candidates.map((item, index) => ({ id: `public-${index}`, name: item.title, logo: image(item.imageUrl), votes: null, rank: index + 1 }))
  };
}
